// Modalidad de una cita: presencial o telemedicina. Los valores son los del
// backend (Cita.MODALIDAD_* en citas.py) y no deben escribirse a mano en cada
// pantalla - la misma condicion vivia repetida y era imposible mantenerla
// consistente entre el dashboard, la agenda y la ficha.
//
// Ojo con el nombre: en `api/escriba.js` existe otra "modalidad" que es la del
// ESCRIBA (presencial_equipo / celular), no la de la cita. Son cosas distintas
// que se llaman igual; este archivo es solo para la de la cita.
export const MODALIDAD_PRESENCIAL = 'presencial';
export const MODALIDAD_TELEMEDICINA = 'telemedicina';

export const MODALIDAD_LABEL = {
  [MODALIDAD_PRESENCIAL]: 'Presencial',
  [MODALIDAD_TELEMEDICINA]: 'Teleconsulta',
};

// El backend trae `presencial` por defecto (server_default), asi que una cita
// sin modalidad se trata como presencial y no como "desconocida": inventar un
// tercer estado en la interfaz complicaria las tres pantallas sin que exista.
export const esTeleconsulta = (cita) =>
  (cita?.modalidad || MODALIDAD_PRESENCIAL) === MODALIDAD_TELEMEDICINA;

// Que la modalidad AGENDADA decida el enfasis no es un candado: el modelo dice
// explicitamente que es "un plan por defecto" y el profesional siempre puede
// atender por el canal que sea. Por eso la accion del otro recorrido nunca se
// oculta, solo deja de ir destacada (ver `variantePrincipal`).
//
// La excepcion es "Marcar llegada" en teleconsulta, que si se oculta: afirma que
// el paciente esta presente fisicamente, y en ese recorrido su equivalente ya
// existe y es automatico (entrar a la sala de espera virtual).
export const permiteMarcarLlegada = (cita) => !esTeleconsulta(cita);

// Ayuda a que las tres superficies de agenda usen el mismo par de variantes en
// vez de decidirlo cada una. `principal` es la accion que corresponde al
// recorrido de la cita; la otra queda en `outline`.
export const varianteAtencion = (cita, principal = 'primary') =>
  (esTeleconsulta(cita) ? 'outline' : principal);

export const varianteVideo = (cita, principal = 'primary') =>
  (esTeleconsulta(cita) ? principal : 'outline');

// El estado `en_espera` significa lo mismo en los dos recorridos -el paciente
// esta ahi y el profesional todavia no arranca- pero no se dice igual. En
// presencial llego caminando; en teleconsulta esta conectado del otro lado, y
// "en espera" a secas se puede leer como "todavia no aparece", que es justo lo
// contrario de lo que informa.
export const etiquetaEspera = (cita) =>
  (esTeleconsulta(cita) ? 'Paciente conectado' : 'Paciente en espera');

export const etiquetaEsperaDestacada = (cita) =>
  (esTeleconsulta(cita) ? 'PACIENTE CONECTADO' : 'PACIENTE EN ESPERA');
